import React, { useEffect, useState } from 'react';
import { Form, Button, Table, InputGroup } from 'react-bootstrap';
import { adminInstance } from '../services/axiosInstance'; 

const SparePublisherPage = () => {
  const [spares, setSpares] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchSpares();
  }, []);

  const fetchSpares = async () => {
    const res = await adminInstance.get(`subgroup/GetSparesBySubGroup/1/1`);
    const sparesWithBool = (res.data.items || []).map(spare => ({
      ...spare,
      IsPublish: !!spare.IsPublish,
    }));
    setSpares(sparesWithBool);
  };

  const togglePublish = (ItemCode) => {
    setSpares(prev =>
      prev.map(spare =>
        spare.ItemCode === ItemCode ? { ...spare, IsPublish: !spare.IsPublish } : spare
      )
    );
  };

  const handleSave = async () => {
    const publishedIds = spares.filter(x => x.IsPublish).map(x => x.ItemCode);
    await adminInstance.put('Item/PublishSpares', publishedIds); // or send full objects depending on API
    alert('Items Published Successfully!');
  };

  const filteredSpares = spares
    .filter(spare =>
      spare.ItemName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      spare.ItemCode?.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      const aChecked = a.IsPublish ? -1 : 1;
      const bChecked = b.IsPublish ? -1 : 1;
      return aChecked - bChecked;
    });

  return (
    <div className="card aon-card">
        <div className="card-header aon-card-header">
            <h4>
                Item Publisher
            </h4>
        </div>
        <div className="card-body aon-card-body">
          <div className="container mt-4">
      <h4>Publish Items to Web</h4>      

      <Button variant="success" onClick={handleSave}>
        Save Published Items
      </Button>

      <Table bordered hover>
        <thead>
          <tr>
            <th>Publish</th>
            <th>Code</th>
            <th>Item Name</th>
          </tr>
        </thead>
        <tbody>
          <tr >
            <td colSpan={3}>
            <InputGroup className="mb-3">
              <Form.Control
                placeholder="Search items..."
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
              />
            </InputGroup>
            </td>
          </tr>
          {filteredSpares.map(spare => (
            <tr key={spare.id}>
              <td>
                <Form.Check
                  type="checkbox"
                  checked={spare.IsPublish}
                  onChange={() => togglePublish(spare.ItemCode)}
                />
              </td>
              <td>{spare.ItemCode}</td>
              <td>{spare.ItemName}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      
          </div>
      </div>
    </div>
  );
};

export default SparePublisherPage;
